<script setup lang="ts">
import Button from '~/components/design-system/button.vue';

const settings = useSiteStore();
const route = useRoute();
const router = useRouter();

const handleConfirm = async () => {
  settings.setDemoPlayTimeout();
  settings.deactivateModal();
};

const handleDecline = () => {
  settings.deactivateModal();
  if (route?.params?.game) {
    router.replace(`/${route.params.contentType}`);
  }
};
</script>

<template>
  <div class="p-4 flex flex-col gap-2">
    <p class="text-base-priority">
      {{ $t('acknowledge-demo-play-body') }}
    </p>
  </div>
  <div class="grid grid-cols-2 gap-2 sm:gap-3 p-4 bg-base w-full">
    <Button
      type="secondary-alternative"
      class="w-full justify-center"
      @click="handleDecline"
    >
      {{ $t('decline-demo-play') }}
    </Button>
    <Button type="primary" class="w-full justify-center" @click="handleConfirm">
      {{ $t('acknowledge-demo-play') }}
    </Button>
  </div>
</template>
